import React, { Component } from "react";
import HomeContent from "../FunctionComponents/HomeFolder/HomeContent.jsx";

class Home extends Component {
  render() {
    return (
      <div>
        <HomeContent />
      </div>
    );
  }
}

export default Home;
